import React, { type ReactNode } from "react";
import { MobileNavContext, ModalContext, PageContext } from "./context";
import "./styles/layout.scss";

interface LayoutProps {
  children: ReactNode;
}

const Wrapper = ({ children }: LayoutProps) => {
  return (
    <>
      <PageContext>
        <ModalContext>
          <MobileNavContext>{children}</MobileNavContext>
        </ModalContext>
      </PageContext>
    </>
  );
};

export default Wrapper;
